import React, { useState, useEffect } from 'react'
import api from '../services/api'
import { useAuth } from '../contexts/AuthContext'

/**
 * Отображает custom_data с резолвом значений справочников (label вместо UUID).
 * Заголовок: "Доп. информация"
 */
function CustomDataDisplay({ entityType, customData, className }) {
  const { user } = useAuth()
  const hasPermission = user?.permissions?.['custom_fields.view']
  const [definitions, setDefinitions] = useState([])
  const [references, setReferences] = useState({})
  const [customReferences, setCustomReferences] = useState({})

  useEffect(() => {
    if (!customData || typeof customData !== 'object' || Object.keys(customData).length === 0) return
    if (!hasPermission) return
    let cancelled = false
    ;(async () => {
      try {
        const [defRes, refRes] = await Promise.all([
          api.get(`/admin/custom-fields/definitions?entity_type=${entityType}`),
          api.get('/admin/reference'),
        ])
        if (!cancelled && defRes.data?.definitions) setDefinitions(defRes.data.definitions)
        if (!cancelled && refRes.data?.references) setReferences(refRes.data.references)
        if (!cancelled && refRes.data?.custom_references) {
          const map = {}
          refRes.data.custom_references.forEach((r) => { map[r.id] = r.values || [] })
          setCustomReferences(map)
        }
      } catch {
        if (!cancelled) setDefinitions([])
      }
    })()
    return () => { cancelled = true }
  }, [entityType, customData, hasPermission])

  if (!customData || typeof customData !== 'object' || Object.keys(customData).length === 0) return null

  const resolveValue = (code, value) => {
    if (value === true || value === false) return value ? 'Да' : 'Нет'
    if (value == null || value === '') return '-'
    const def = definitions.find((d) => d.code === code)
    if (!def || def.field_type !== 'reference') return String(value)
    if (def.reference_type) {
      const list = references[def.reference_type] || []
      const item = list.find((r) => r.id === value)
      return item ? (item.name || item.code || value) : '-'
    }
    if (def.custom_reference_id) {
      const list = customReferences[def.custom_reference_id] || []
      const item = list.find((r) => r.id === value)
      return item ? (item.label || item.value || value) : '-'
    }
    const opts = def.options || []
    const opt = opts.find((o) => String(o.value) === String(value) || o.id === value)
    return opt ? (opt.label || opt.value || value) : '-'
  }

  const getLabel = (code) => {
    const def = definitions.find((d) => d.code === code)
    return def ? def.label : code
  }

  const entries = Object.entries(customData).filter(([, v]) => v !== undefined && v !== null && (typeof v !== 'string' || v !== ''))

  if (entries.length === 0) return null

  return (
    <div className={className || 'card-section'}>
      <h2>Доп. информация</h2>
      <div className="info-grid">
        {entries.map(([key, value]) => (
          <div key={key} className="info-item">
            <label>{getLabel(key)}</label>
            <span>{resolveValue(key, value)}</span>
          </div>
        ))}
      </div>
    </div>
  )
}

export default CustomDataDisplay
